

import React, { useState, useEffect } from 'react';
import { Card } from "@mui/material";
import { api } from '../../../../services/api'; // Supondo que seu serviço de API esteja configurado

// Componentes de UI (exemplo, ajuste conforme sua biblioteca)
import VuiBox from '../../../../components/VuiBox';
import VuiTypography from '../../../../components/VuiTypography';
import VuiInput from '../../../../components/VuiInput';
import VuiButton from '../../../../components/VuiButton';

function PixelSetup() {
  const [trackingId, setTrackingId] = useState('Carregando...');
  const [snippet, setSnippet] = useState('');
  const [copySuccess, setCopySuccess] = useState('');

  // Atualiza o snippet sempre que o backend informar o trackingId mais recente.
  useEffect(() => {
    async function fetchTrackingId() {
      try {
        const response = await api.get('/settings/company/pixel-settings');
        const id = response.trackingId;
        setTrackingId(id);
        setSnippet(
          `<!-- Pixel SaferDock -->\n` +
          `<script>\n` +
          `  window.PIXURE_API_URL = 'https://api.saferdock.com/api';\n` +
          `  window.PIXURE_TRACKING_ID = '${id}';\n` +
          `</script>\n` +
          `<script async src="https://api.saferdock.com/pixel/pixel.js"></script>
` +
          `<!-- Fim do Pixel SaferDock -->`
        );
      } catch (error) {
        console.error("Erro ao buscar o tracking ID:", error);
        setTrackingId('Não foi possível carregar o ID');
      }
    }

    fetchTrackingId();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(snippet).then(() => {
      setCopySuccess('Copiado!');
      setTimeout(() => setCopySuccess(''), 2000);
    }, (err) => {
      setCopySuccess('Falha ao copiar!');
      console.error('Erro ao copiar o snippet: ', err);
    });
  };

  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="24px">
          <VuiTypography color="white" variant="lg" fontWeight="bold">
            Pixel de Rastreamento
          </VuiTypography>
        </VuiBox>
        <VuiBox flexGrow={1} display="flex" flexDirection="column">
          <VuiTypography variant="body2" color="text" mb="24px">
            Copie e cole o código abaixo na tag &lt;head&gt; do seu site para começar a rastrear seus leads.
          </VuiTypography>

          <VuiBox mb={2}>
            <VuiTypography variant="caption" color="text" mb={1} display="block">
              Seu Tracking ID Único
            </VuiTypography>
            <VuiInput value={trackingId} disabled fullWidth />
          </VuiBox>

          <VuiBox>
            <VuiTypography variant="caption" color="text" mb={1} display="block">
              Snippet de Instalação
            </VuiTypography>
            <VuiBox
              component="pre"
              sx={{
                background: 'rgba(255, 255, 255, 0.05)',
                padding: '16px',
                borderRadius: '8px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                fontSize: '14px',
                fontFamily: 'monospace',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}
            >
              {snippet || 'Carregando snippet...'}
            </VuiBox>
            <VuiButton onClick={handleCopy} color="info" sx={{ mt: 2 }}>
              {copySuccess || 'Copiar Código'}
            </VuiButton>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default PixelSetup;
